import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { formatTime24to12 } from "../../common/commonFunctions";

declare var $: any; // for Bootstrap modal control

export default function ShiftExtensionRequestModal({ show, onClose, onSubmit, currentShiftEnd, loading }) {
  const [extendedStart, setExtendedStart] = useState('');
  const [extendedEnd, setExtendedEnd] = useState('');
  const [reason, setReason] = useState('');
  const parsedCurrentShiftEnd = currentShiftEnd ? JSON.parse(currentShiftEnd) : '';

  useEffect(() => {
    if (show) {
      $('#shift-extension-modal').modal('show');
    } else {
      $('#shift-extension-modal').modal('hide');
    }
  }, [show]);

  useEffect(() => {
    if (!show) {
      setExtendedStart('');
      setExtendedEnd('');
      setReason('');
    }
  }, [show]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!extendedStart) {
      alert('Please select extended start time');
      return;
    }
    if (!extendedEnd) {
      alert('Please select extended end time');
      return;
    }
    if (dayjs(extendedEnd, 'HH:mm').isBefore(dayjs(extendedStart, 'HH:mm'))) {
      alert('Extended End Time must be after Extended Start Time.');
      return;
    }
    if (!reason.trim()) {
      alert('Please provide a reason');
      return;
    }

    onSubmit({
      extendedStart,
      extendedEnd,
      reason,
    });
  };

  return (
    <div
      className="modal fade"
      id="shift-extension-modal"
      data-backdrop="static"
      data-keyboard="false"
      tabIndex={-1}
    >
      <div className="modal-dialog">
        <div className="modal-content" style={{ borderRadius: '10px' }}>
          <div className="modal-header">
            <h5 className="modal-title">Request Shift Extension</h5>
            <button
              type="button"
              className="close"
              // data-dismiss="modal"
              // aria-label="Close"
              onClick={onClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>          </div>
          <div className="modal-body">
            <p>
              Current shift ends at: <b>{formatTime24to12(parsedCurrentShiftEnd)}</b>
            </p>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label>Extended Start Time</label>
                <input
                  type="time"
                  className="form-control"
                  value={extendedStart}
                  onChange={(e) => setExtendedStart(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label>Extended End Time</label>
                <input
                  type="time"
                  className="form-control"
                  value={extendedEnd}
                  onChange={(e) => setExtendedEnd(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label>Reason for Extension</label>
                <textarea
                  rows={3}
                  className="form-control"
                  placeholder="Enter reason"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                ></textarea>
              </div>
              <div className="d-flex justify-content-end">
                <button type="submit" className="btn btn-primary m-1" disabled={loading}>
                  {loading ? (
                    <i className="fa fa-spinner fa-spin"></i>
                  ) : "Submit Request"}
                </button>
                <button type="button" className="btn btn-danger m-1" onClick={onClose}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
